import { ConfirmationModal, Text } from '@shared/components';
import { useSnackbar } from '@shared/snackbar';
import {
  SearchUserAppRoleViewDocument,
  useUnassignUserAppRolesMutation,
} from '@user-management/graphql';

import { useRoleUserManagementModal } from '../../providers';

enum RemoveUserFromRoleErrorType {
  // NOTED: Assume that the error message which is CANNOT_ASSIGN_APPROLE_TO_SELF is the prohibited for remove their self
  TRYING_TO_REMOVE_SELF = 'CANNOT_ASSIGN_APPROLE_TO_SELF',
}

const ERROR_MESSAGE: Record<RemoveUserFromRoleErrorType, string> = {
  [RemoveUserFromRoleErrorType.TRYING_TO_REMOVE_SELF]: 'ไม่สามารถนำตัวเองออกได้',
};

interface RoleUserDeletionModalProps {
  open: boolean;
  onClose: () => void;
  userId: string;
  appRoleId: string;
}

export default function RoleUserDeletionModal(props: Readonly<RoleUserDeletionModalProps>) {
  const { open: isOpen, onClose, userId, appRoleId } = props;

  const { close } = useRoleUserManagementModal();
  const { showSnackbar } = useSnackbar();

  const [unassignUserAppRoles, { loading: isUnassignUserAppRoles }] =
    useUnassignUserAppRolesMutation({
      onCompleted: (res) => {
        if (res.suUnassignUserAppRoles.success) {
          showSnackbar({ message: 'Remove User Successfully', variant: 'success' });
          close();
        } else {
          let message = res.suUnassignUserAppRoles.message ?? 'Remove User Unsuccessfully';
          if (message.includes(RemoveUserFromRoleErrorType.TRYING_TO_REMOVE_SELF)) {
            message = ERROR_MESSAGE[RemoveUserFromRoleErrorType.TRYING_TO_REMOVE_SELF];
          }
          showSnackbar({ message: message, variant: 'error' });
        }
      },
      onError: (error) => {
        const errorMessage = error?.message || 'Error!';
        showSnackbar({ message: errorMessage, variant: 'error' });
      },
      awaitRefetchQueries: true,
      refetchQueries: [SearchUserAppRoleViewDocument],
    });

  const handleDeleteUserFromRole = () => {
    unassignUserAppRoles({
      variables: {
        data: {
          appRoleIds: [appRoleId],
          userId,
        },
      },
    });
  };

  return (
    <ConfirmationModal
      open={isOpen}
      title='Remove user?'
      content={
        <Text>This will remove the user&apos;s access to features associated with this role.</Text>
      }
      maxWidth='xs'
      acceptText='Remove'
      variant='error'
      loading={isUnassignUserAppRoles}
      onClose={onClose}
      onDiscard={onClose}
      onAccept={handleDeleteUserFromRole}
    />
  );
}
